import deburr from "lodash/deburr";
import axios from "axios";
import React, {Component} from "react";
import AutocompleteSearch from "../AutocompleteSearch";
import match from "autosuggest-highlight/match";
import parse from "autosuggest-highlight/parse";
import MenuItem from "@material-ui/core/MenuItem";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core";
import {urlConfig} from "../config";

const styles = theme => ({});

class MomentClipSearch extends Component {

    constructor(props) {
        super(props);
    }

    handleClipMomentSearchRequest = (value) => {

        const inputValue = deburr(value.trim()).toLowerCase();

        const inputLength = inputValue.length;
        let count = 0;

        let serverUrl = `${urlConfig.momentsServiceUrl}/momentClips?title=${inputValue}`;

        const momentClipSearchInstance = axios.create({
            baseURL: `${serverUrl}`
        });

        return momentClipSearchInstance.get()

    };

    getSuggestions = (value, suggestions) => {
        const inputValue = deburr(value.trim()).toLowerCase();
        const inputLength = inputValue.length;
        let count = 0;

        return inputLength === 0
            ? []
            : suggestions.filter(suggestion => {
                const keep =
                    count < 5 && suggestion.title.slice(0, inputLength).toLowerCase() === inputValue;

                if (keep) {
                    count += 1;
                }

                return keep;
            });
    };

    getSuggestionValue = (suggestion) => {
        return suggestion.title
    };

    handleSuggestionSelected = (event, {suggestion, suggestionValue, suggestionIndex, sectionIndex, method}) => {

        let suggestionValueParsed = suggestion.id;

        this.props.handleSuggestionSelect(suggestionValueParsed, suggestion);
    };

    renderSuggestion = (suggestion, {query, isHighlighted}) => {
        const matches = match(suggestion.title, query);
        const parts = parse(suggestion.title, matches);

        return (
            <MenuItem selected={isHighlighted} component="div">
                <div>
                    {parts.map((part, index) => {
                        return part.highlight ? (
                            <span key={String(index)} style={{fontWeight: 500}}>
              {part.text}
            </span>
                        ) : (
                            <strong key={String(index)} style={{fontWeight: 300}}>
                                {part.text}
                            </strong>
                        );
                    })}
                </div>
            </MenuItem>
        );
    };

    render() {
        return (<AutocompleteSearch
            suggestions={this.props.suggestions}
            inputSearchText={this.props.inputSearchText}
            handleSuggestionSelect={this.props.handleSuggestionSelect}
            handleSuggestionSelected={this.handleSuggestionSelected}
            handleSearchRequest={this.handleClipMomentSearchRequest}
            inputPlaceholder={'Search with Clip Moment Title here'}
            getSuggestions={this.getSuggestions}
            getSuggestionValue={this.getSuggestionValue}
            renderSuggestion={this.renderSuggestion}/>)
    }
}


MomentClipSearch.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};
export default withStyles(styles, {withTheme: true})(MomentClipSearch);